import * as React from 'react';
import { Button, CallOrder16 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { useCallbackButton } from './useCallbackButton';

export function BasicCallbackButton() {
  const [isAvailable, handleClick] = useCallbackButton('blockJK');
  const isFlatViewOrderEnabled = useSelector(getIsFlatViewOrderEnabled);

  if (!isAvailable) {
    return null;
  }

  return isFlatViewOrderEnabled ? (
    <Button
      theme="fill_white_primary"
      size={'M'}
      beforeIcon={<CallOrder16 color={'primary_100'} />}
      onClick={handleClick}
    />
  ) : (
    <Button theme="fill_white_primary" onClick={handleClick}>
      Перезвоните мне
    </Button>
  );
}
